import { Fragment } from "react/jsx-runtime";
import { Button, Col, Layout, Row, Typography } from "antd";
import { CONTACT_US } from "../../../constants/AppConstants";
import {
  FacebookFilled,
  InstagramFilled,
  MailFilled,
  TikTokFilled,
  WhatsAppOutlined,
} from "@ant-design/icons";
import logo from "../../../assets/images/Logo-Rifas-Gran-Familia.png";
import "./Contact.css";

const { Title, Text, Link } = Typography;

const iconStyle = {
  fontSize: "24px",
  color: "#fff",
};

export default function Contact() {
  return (
    <Layout className="contactus-container">
      <Row>
        <Col md={16}>
          <Title level={2} strong>
            {CONTACT_US.TITLE}
          </Title>
          {CONTACT_US.DESCRIPTION.split("\n").map((linea, index) => (
            <Fragment key={index}>
              <Text>{linea}</Text>
              <br />
            </Fragment>
          ))}
          <div className="contactus-icons">
            <Button
              type="link"
              href="https://www.facebook.com/share/1BzuzWbdrC/?mibextid=wwXIfr"
              target="_blank"
              className="icons-buttons"
              style={{ backgroundColor: "#1877F2" }}
            >
              <FacebookFilled style={iconStyle} />
            </Button>
            <Button
              type="link"
              href="https://www.instagram.com/rifasgranfamiliagdl_"
              target="_blank"
              className="icons-buttons"
              style={{ backgroundColor: "#E4405F" }}
            >
              <InstagramFilled style={iconStyle} />
            </Button>
            <Button
              type="link"
              href="mailto:contacto@rifasgranfamiliagdl.com.mx"
              target="_blank"
              className="icons-buttons"
              style={{ backgroundColor: "#D44638" }}
            >
              <MailFilled style={iconStyle} />
            </Button>
            <Button
              type="link"
              href="https://api.whatsapp.com/send?phone=523318415075"
              target="_blank"
              className="icons-buttons"
              style={{ backgroundColor: "#25D366" }}
            >
              <WhatsAppOutlined style={iconStyle} />
            </Button>
            <Button
              type="link"
              href="https://www.tiktok.com/@rifasgranfamiliagdl_"
              target="_blank"
              className="icons-buttons"
              style={{ backgroundColor: "#666666" }}
            >
              <TikTokFilled style={iconStyle} />
            </Button>
          </div>
        </Col>
        <Col className="contactus-col-logo" md={8}>
          <Link className="contactus-logo" to="/">
            <img
              src={logo}
              alt="Rifas Gran Familia GDL"
              style={{ maxHeight: "150px" }}
            />
          </Link>
        </Col>
      </Row>
    </Layout>
  );
}
